export default {
  title: 'Odesláno!',
  text: 'Vaši žádost jsme úspěšně<br>zpracovali a brzy se Vám ozveme',
};
